/*
 Copyright 2015, 2016 OpenMarket Ltd

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

 http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matrixJsSdk = require('matrix-js-sdk');

var _Flair = require('../elements/Flair.js');

var _Flair2 = _interopRequireDefault(_Flair);

var _FlairStore = require('../../../stores/FlairStore');

var _FlairStore2 = _interopRequireDefault(_FlairStore);

var _languageHandler = require('../../../languageHandler');

var _FormattingUtils = require('../../../utils/FormattingUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
    displayName: 'SenderProfile',
    propTypes: {
        mxEvent: _propTypes2.default.object.isRequired, // event whose sender we're showing
        text: _propTypes2.default.string, // Text to show. Defaults to sender name
        onClick: _propTypes2.default.func
    },

    contextTypes: {
        matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient)
    },

    getInitialState: function getInitialState() {
        return {
            userGroups: null,
            relatedGroups: []
        };
    },
    componentWillMount: function componentWillMount() {
        var _this = this;

        this.unmounted = false;
        this._updateRelatedGroups();

        _FlairStore2.default.getPublicisedGroupsCached(this.context.matrixClient, this.props.mxEvent.getSender()).then(function (userGroups) {
            if (_this.unmounted) return;
            _this.setState({ userGroups: userGroups });
        });

        this.context.matrixClient.on('RoomState.events', this.onRoomStateEvents);
    },
    componentWillUnmount: function componentWillUnmount() {
        this.unmounted = true;
        this.context.matrixClient.removeListener('RoomState.events', this.onRoomStateEvents);
    },
    onRoomStateEvents: function onRoomStateEvents(event) {
        if (event.getType() === 'm.room.related_groups' && event.getRoomId() === this.props.mxEvent.getRoomId()) {
            this._updateRelatedGroups();
        }
    },
    _updateRelatedGroups: function _updateRelatedGroups() {
        if (this.unmounted) return;
        var room = this.context.matrixClient.getRoom(this.props.mxEvent.getRoomId());
        if (!room) return;

        var relatedGroupsEvent = room.currentState.getStateEvents('m.room.related_groups', '');
        this.setState({
            relatedGroups: relatedGroupsEvent ? relatedGroupsEvent.getContent().groups || [] : []
        });
    },
    _getDisplayedGroups: function _getDisplayedGroups(userGroups, relatedGroups) {
        var displayedGroups = userGroups || [];
        if (relatedGroups && relatedGroups.length > 0) {
            displayedGroups = relatedGroups.filter(function (groupId) {
                return displayedGroups.includes(groupId);
            });
        } else {
            displayedGroups = [];
        }
        return displayedGroups;
    },
    render: function render() {
        var mxEvent = this.props.mxEvent;

        var colorClass = (0, _FormattingUtils.getUserNameColorClass)(mxEvent.getSender());
        var name = mxEvent.sender ? mxEvent.sender.name : mxEvent.getSender();

        var _mxEvent$getContent = mxEvent.getContent(),
            msgtype = _mxEvent$getContent.msgtype;

        if (msgtype === 'm.emote') {
            return _react2.default.createElement('span', null); // emote message must include the name so don't duplicate it
        }

        var flair = _react2.default.createElement('div', null);
        if (this.props.enableFlair) {
            var displayedGroups = this._getDisplayedGroups(this.state.userGroups, this.state.relatedGroups);

            flair = _react2.default.createElement(_Flair2.default, { key: 'flair',
                userId: mxEvent.getSender(),
                groups: displayedGroups
            });
        }

        var nameElem = name || '';

        // Name + flair
        var nameFlair = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
                'span',
                { className: 'mx_SenderProfile_name ' + colorClass },
                nameElem
            ),
            flair
        );

        var content = this.props.text ? _react2.default.createElement(
            'span',
            { className: 'mx_SenderProfile_aux' },
            (0, _languageHandler._t)(this.props.text, { senderName: function senderName() {
                    return nameElem;
                } })
        ) : nameFlair;

        return _react2.default.createElement(
            'div',
            { className: 'mx_SenderProfile', dir: 'auto', onClick: this.props.onClick },
            content
        );
    }
});
module.exports = exports['default'];
//# sourceMappingURL=SenderProfile.js.map